export function getDefaultProviderFilterFormState() {
    return {
        blacklistWhitelistState: true,
        providerListText: "",
        stockState: { green: true, yellow: true, red: true },
        minRating: 0,
    }
}

export function parseProviderFilterData(filterData) {
    const defaults = getDefaultProviderFilterFormState()
    if (filterData == null || filterData === "") {
        return defaults
    }

    const trimmed = String(filterData).trim()
    if (!trimmed) {
        return defaults
    }

    if (!trimmed.startsWith("{")) {
        return {
            ...defaults,
            providerListText: trimmed,
        }
    }

    try {
        const node = JSON.parse(trimmed)
        const providers = []
        if (Array.isArray(node.providers)) {
            providers.push(...node.providers.map(String))
        }
        if (Array.isArray(node.wildcard_providers)) {
            providers.push(...node.wildcard_providers.map(String))
        }

        const listType = String(node.list_type || node.listType || "BLACKLIST").toUpperCase()
        const stocks = Array.isArray(node.stocks) ? node.stocks.map(String) : []

        return {
            blacklistWhitelistState: listType !== "WHITELIST",
            providerListText: providers.join(", "),
            stockState: {
                green: stocks.length === 0 || stocks.includes("GREEN"),
                yellow: stocks.length === 0 || stocks.includes("YELLOW"),
                red: stocks.length === 0 || stocks.includes("RED"),
            },
            minRating: node.min_reviews ?? node.minReviews ?? 0,
        }
    } catch {
        return {
            ...defaults,
            providerListText: trimmed,
        }
    }
}

export function serializeProviderFilterData({ providerListText, blacklistWhitelistState, stockState, minRating }) {
    const providers = []
    const wildcardProviders = []

    String(providerListText || "")
        .split(",")
        .map((entry) => entry.trim())
        .filter(Boolean)
        .forEach((provider) => {
            if (provider.includes("%")) {
                wildcardProviders.push(provider)
            } else {
                providers.push(provider)
            }
        })

    const stocks = []
    if (stockState.green) {
        stocks.push("GREEN")
    }
    if (stockState.yellow) {
        stocks.push("YELLOW")
    }
    if (stockState.red) {
        stocks.push("RED")
    }

    const payload = {
        stocks,
        providers,
        wildcard_providers: wildcardProviders,
        list_type: blacklistWhitelistState ? "BLACKLIST" : "WHITELIST",
    }

    const minReviews = Number(minRating)
    if (Number.isFinite(minReviews)) {
        payload.min_reviews = minReviews
    }

    return JSON.stringify(payload)
}
